import React, { useContext } from "react";
import SiteContext from "./SiteContext.jsx";
import TopBar from "./TopBar.jsx";
import RequestButton from "./RequestButton.jsx";
import FolderOpenIcon from "./icons/FolderOpenIcon.jsx";
import EditLocationIcon from "./icons/EditLocationIcon.jsx";
import ShortTextIcon from "./icons/ShortTextIcon.jsx";
import AccountBoxIcon from "./icons/AccountBoxIcon.jsx";
import AddPhotosButton from "./AddPhotosButton.jsx";
import RequestField from "./RequestField.jsx";
import RadioField from "./RadioField.jsx";
import SkipScreenshotFlag from "./SkipScreenshotFlag.jsx";

export default function CreateRequest() {
  const { hasCrm } = useContext(SiteContext);

  if (!hasCrm) {
    return (
      <>
        <SkipScreenshotFlag />
        <div className='tw-flex tw-h-[100svh]'>
          <p className='tw-m-auto'>This site doesn’t support CRM</p>
        </div>
      </>
    );
  }

  return (
    <>
      <TopBar title='Graffiti' />

      <div className='tw-bg-grey-[#FAFAFA]'>
        <img
          src='/assets/appPreviews/graffiti.png'
          alt=''
          width='2048'
          height='397'
          className='tw-block tw-h-[200px] tw-max-w-full tw-object-cover tw-object-center md:tw-h-[132px]'
        />

        <div className='tw-bg-white tw-p-5 tw-pt-4'>
          <div className='tw-flex'>
            <div className='tw-ml-auto'>
              <AddPhotosButton />
            </div>
          </div>

          <div className='tw-mt-4 tw-flex tw-flex-col tw-gap-1'>
            <RequestField icon={() => <FolderOpenIcon />} title='Topic' value='Graffiti' />
            <RequestField icon={() => <EditLocationIcon />} title='Location' value='123 Main Street' />
            <RequestField
              icon={() => <ShortTextIcon />}
              title='Description'
              value='I hope this helps keep our community clean and beautiful'
              type='textarea'
            />
            <RequestField icon={() => <AccountBoxIcon />} title='My Contact Info' value='J. Doe' type='subform' />
          </div>
        </div>
      </div>

      <div className='tw-pl-4 tw-pr-4 tw-pt-10'>
        <div className='tw-flex tw-justify-center tw-gap-9'>
          <RadioField label='Private' checked />
          <RadioField label='Anonymous' />
        </div>

        <p className='tw-m-4 tw-text-center tw-text-[#606060]'>
          This issue and your contact info will only be visible to verified officials.
        </p>

        <div className='tw-flex'>
          <div className='tw-m-auto tw-mt-3'>
            <RequestButton label='Submit Request' small />
          </div>
        </div>
      </div>
    </>
  );
}
